import { Component } from '@angular/core';
import { Router, Event, NavigationStart } from '@angular/router';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  templateUrl: './app.component.html',
  //template: '<router-outlet><livechat-widget licenseId="7424591"></livechat-widget><div *dynamicComponent="template;"></div></router-outlet>'
})
export class AppComponent { 

    template: string = '';
    showChat = true;
  
    constructor(private router: Router) {}
    
    ngOnInit(): void {
       
        this.router.events.subscribe( (e) => {
            if (e instanceof NavigationStart) {
                if (e.url.indexOf('/admin/') == -1) {
                    //this.template = `<div class="live_chat"><div data-id="PTM9l29JK6d" class="livechat_button"><a href="https://www.livechatinc.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_7424591"></a></div></div>`;
                    this.showChat = true;
                } else {
                   this.showChat = false;
                }
            }
        });
    }
    
    ngAfterViewInit() {
        this.router.events.subscribe( (e) => {
            if (e instanceof NavigationStart && (document.querySelector('#chat-widget-container') as HTMLElement)) {
                if (e.url.indexOf('/admin/') == -1) {
                    (document.querySelector('#chat-widget-container') as HTMLElement).style.visibility = 'visible';
                } else {
                    (document.querySelector('#chat-widget-container') as HTMLElement).style.visibility = 'hidden';
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/app.component.ts